import type {TrustAccountGuestEventDTO, TrustAccountMemberEventDTO} from '@sollapay/types';

export type ShareLogEntry =
  | {kind: 'member'; event: TrustAccountMemberEventDTO}
  | {kind: 'guest'; event: TrustAccountGuestEventDTO};

/** Team and guest changes in one list, newest first. */
export function mergeShareLog(
  memberEvents: readonly TrustAccountMemberEventDTO[],
  guestEvents: readonly TrustAccountGuestEventDTO[]
): ShareLogEntry[] {
  return [
    ...memberEvents.map(event => ({kind: 'member' as const, event})),
    ...guestEvents.map(event => ({kind: 'guest' as const, event}))
  ].sort((a, b) => b.event.createdAt.localeCompare(a.event.createdAt));
}
